import React from 'react'
import { Modal } from 'react-bootstrap'

export default class TourModalContainer extends React.Component {
   /* Has to be multiple single arguments for IE compatibility */
  render() {
 
    document.body.classList.remove('tour-item-dashboard')
    document.body.classList.remove('tour-item-results')
    document.body.classList.remove('tour-item-analysis')
    document.body.classList.remove('tour-item-scans')
    document.body.classList.remove('tour-item-new-scan')
    document.body.classList.remove('tour-item-units')
    document.body.classList.remove('tour-item-employees')
    document.body.classList.remove('tour-item-print')
    document.body.classList.remove('tour-item-account')
    document.body.classList.remove('tour-item-logo')

    document.body.classList.add(this.props.currentclass)

    this.props.nextindicator && document.getElementById("navigation").getElementsByClassName(this.props.nextindicator)[0].classList.remove('active')
    this.props.previndicator && document.getElementById("navigation").getElementsByClassName(this.props.previndicator)[0].classList.remove('active')

    if (this.props.currentindicator) {
      document.getElementById("navigation").getElementsByClassName(this.props.currentindicator)[0].classList.add('active')
    }

    return (
      <div className="modal-container">
        <div className="tour-indicator"></div>
        <Modal.Header>
          <Modal.Title id="contained-modal-title-lg">
           {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.bodytext}
        </Modal.Body>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Tour/modals/tourmodalcontent.js